export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },  
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/auth/Login.vue`
    )
  },
  {
    path: '/',
    meta: { },
    name: 'Root',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/promosi',
    meta: { breadcrumb: true },
    name: 'Promosi',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Promosi.vue`
    )
  },
  {
    path: '/edit-promosi/:uuid?',
    meta: { breadcrumb: true },
    name: 'EditPromosi',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/promosi/EditPromosi.vue`
    )
  },
  {
    path: '/perusahaan',
    meta: { breadcrumb: true },
    name: 'Perusahaan',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Perusahaan.vue`
    )
  },
  {
    path: '/edit-perusahaan/:uuid?',
    meta: { breadcrumb: true },
    name: 'EditPerusahaan',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/perusahaan/EditPerusahaan.vue`
    )
  },
  {
    path: '/gapoktan',
    meta: { breadcrumb: true },
    name: 'Gapoktan',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Gapoktan.vue`
    )
  },
  {
    path: '/tambahkan-gapoktan',
    meta: { breadcrumb: true },
    name: 'TambahkanGapoktan',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/gapoktan/TambahkanGapoktan.vue`
    )
  },
  {
    path: '/tambahkan-gapoktan-lahan',
    meta: { breadcrumb: true },
    name: 'TambahkanGapoktanLahan',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/gapoktan/TambahkanGapoktanLahan.vue`
    )
  },

  // Pemerintah
  {
    path: '/pemerintah',
    meta: { breadcrumb: true },
    name: 'Pemerintah',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Pemerintah.vue`
    )
  },
  {
    path: '/edit-pemerintah/:uuid?',
    meta: { breadcrumb: true },
    name: 'EditPemerintah',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/pemerintah/EditPemerintah.vue`
    )
  },
  {
    path: '/tambahkan-pemerintah',
    meta: { breadcrumb: true },
    name: 'TambahkanPemerintah',
    component: () => import(
      `@/components/pemerintah/TambahkanPemerintah.vue`
    )
  },
  
  // kontrak
  {
    path: '/kontrak',
    meta: { breadcrumb: true },
    name: 'Kontrak',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Kontrak.vue`
    )
  },
  {
    path: '/tambahkan-kontrak',
    meta: { breadcrumb: true },
    name: 'TambahkanKontrak',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/kontrak/TambahkanKontrak.vue`
    )
  },
  {
    path: '/ulas-kontrak',
    meta: {
      public: true,
    },
    name: 'UlasKontrak',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/kontrak/UlasKontrak.vue`
    )
  },
  {
    path: '/edit-kontrak/:uuid?',
    meta: { breadcrumb: true },
    name: 'EditKontrak',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/kontrak/EditKontrak.vue`
    )
  },
  
  // Pesanan Pengiriman
  {
    path: '/pesanan-pengiriman',
    meta: { breadcrumb: true },
    name: 'PesananPengiriman',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/PesananPengiriman.vue`
    )
  },
  {
    path: '/edit-pesanan-pengiriman/:uuid?',
    meta: { breadcrumb: true },
    name: 'EditPesananPengiriman',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/pesananpengiriman/EditPesananPengiriman.vue`
    )
  },
  {
    path: '/tambahkan-pesanan-pengiriman',
    meta: { breadcrumb: true },
    name: 'TambahkanPesananPengiriman',
    component: () => import(
      `@/components/pesananpengiriman/TambahkanPesananPengiriman.vue`
    )
  },

  // Pergerakan Barang
  {
    path: '/pergerakan-barang',
    meta: { breadcrumb: true },
    name: 'PergerakanBarang',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/PergerakanBarang.vue`
    )
  },
  {
    path: '/edit-pesanan-pengiriman/:uuid?',
    meta: { breadcrumb: true },
    name: 'EditPergerakanBarang',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/pergerakanbarang/EditPergerakanBarang.vue`
    )
  },
  {
    path: '/tambahkan-pergerakan-barang',
    meta: { breadcrumb: true },
    name: 'TambahkanPergerakanBarang',
    component: () => import(
      `@/components/pergerakanbarang/TambahkanPergerakanBarang.vue`
    )
  },

  // Komoditas
  {
    path: '/komoditas',
    meta: { breadcrumb: true },
    name: 'Komoditas',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Komoditas.vue`
    )
  },
  {
    path: '/detail-komoditas',
    meta: { breadcrumb: true },
    name: 'DetailKomoditas',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditas/DetailKomoditas.vue`
    )
  },
  {
    path: '/tambahkan-pesanan-pengiriman-komoditas',
    meta: { breadcrumb: true },
    name: 'TambahkanPesananPengiriman',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditas/TambahkanPesananPengiriman.vue`
    )
  },
  {
    path: '/ulas-pesanan-pengiriman',
    meta: {
      public: true,
    },
    name: 'UlasPesananPengiriman',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditas/UlasPesananPengiriman.vue`
    )
  },

  // Pedagang Perantara
  {
    path: '/komoditas-pedagang-perantara',
    meta: { breadcrumb: true },
    name: 'KomoditasPedagangPerantara',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/KomoditasPedagangPerantara.vue`
    )
  },
  {
    path: '/detail-komoditas-pedagang-perantara',
    meta: { breadcrumb: true },
    name: 'DetailKomoditasPedagangPerantara',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditaspedagangperantara/DetailKomoditas.vue`
    )
  },
  {
    path: '/tambahkan-pesanan-pengiriman-pedagang-perantara',
    meta: { breadcrumb: true },
    name: 'TambahkanPesananPengirimanPedagangPerantara',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditaspedagangperantara/TambahkanPesananPengiriman.vue`
    )
  },
  {
    path: '/ulas-pesanan-pengiriman-pedagang-perantara',
    meta: {
      public: true,
    },
    name: 'UlasPesananPengirimanPedagangPerantara',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditaspedagangperantara/UlasPesananPengiriman.vue`
    )
  },

  // Komoditas Logistik
  {
    path: '/komoditas-logistik',
    meta: { breadcrumb: true },
    name: 'KomoditasLogistik',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/KomoditasLogistik.vue`
    )
  },
  {
    path: '/detail-komoditas-logistik',
    meta: { breadcrumb: true },
    name: 'DetailKomoditasLogistik',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditaslogistik/DetailKomoditas.vue`
    )
  },
  {
    path: '/tambahkan-pesanan-pengiriman-logistik',
    meta: { breadcrumb: true },
    name: 'TambahkanPesananPengirimanLogistik',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditaslogistik/TambahkanPesananPengiriman.vue`
    )
  },
  {
    path: '/ulas-pesanan-pengiriman-logistik',
    meta: {
      public: true,
    },
    name: 'UlasPesananPengirimanLogistik',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditaslogistik/UlasPesananPengiriman.vue`
    )
  },
  {
    path: '/alokasi-detail-logistik/:id?',
    meta: { breadcrumb: true },
    name: 'AlokasiDetailLogistik',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/komoditaslogistik/AlokasiDetail.vue`
    )
  },

  // Feedback
  {
    path: '/feedback',
    meta: { breadcrumb: true },
    name: 'Feedback',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Feedback.vue`
    )
  },
  {
    path: '/tambahkan-feedback',
    meta: { breadcrumb: true },
    name: 'TambahkanFeedback',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/feedback/TambahkanFeedback.vue`
    )
  },
];
